// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main_path_list {\r\n\tcolor: black;\r\n\toverflow-y: scroll;\r\n\tmax-height: 111px;\r\n\tmargin: 8px;\r\n\tbackground: white;\r\n}\r\n\r\n.item_path {\r\n\tmargin: 3px;\r\n\tmargin-left: 10px;\r\n\tborder: solid 2px;\r\n\tdisplay: block;\r\n\toverflow: hidden;\r\n\tbackground: white;\r\n\tborder-color: #006ca1;\r\n\tborder-radius: 3px;\r\n\tmargin-right: 10px;\r\n\tfilter: brightness(0.7);\r\n}\r\n\r\n.item_path:hover {\r\n\tfilter: brightness(1);\r\n}\r\n", ""]);
// Exports
module.exports = exports;
